import { makeStyles } from "@material-ui/core";
import { Colors } from "styles/Colors";

const TRANSITION = "200ms cubic-bezier(0.4, 0, 0.2, 1)";

export const useAuthStyles = makeStyles({
	panel: {
		"&&": {
			width: 384,
			maxWidth: "calc(100vw - 32px)",
			paddingTop: 5,
			boxSizing: "border-box",
		},
	},
	body: {
		"&&&": {
			paddingBottom: 27,
		},
	},
	column: {
		width: 320,
		maxWidth: "100%",
		margin: "0 auto",
	},
	field: {
		marginTop: 16,
		"& .MuiFormHelperText-root": {
			textAlign: "left",
		},
	},
	formError: {
		margin: "30px 0 0",
		fontSize: 13,
		lineHeight: 1.4,
		color: Colors.error,
		textAlign: "center",
	},
	submit: {
		"&&": {
			display: "flex",
			width: "100%",
			margin: "30px 0 0",
			"&:hover": {
				backgroundColor: Colors.secondary,
				filter: "brightness(1.08)",
				boxShadow: "none",
			},
		},
	},
	secondary: {
		"&&": {
			display: "flex",
			width: "100%",
			margin: "14px 0 0",
			padding: 6,
			color: Colors.pickstop,
			fontSize: 12,
			fontWeight: 600,
			letterSpacing: "0.18em",
			backgroundColor: "transparent",
			"&:hover": {
				backgroundColor: "transparent",
				opacity: 0.85,
			},
		},
	},
	rule: {
		display: "flex",
		alignItems: "center",
		margin: "24px 0 16px",
		color: Colors.primaryDarker,
		fontSize: 11,
		letterSpacing: 1.2,
		textTransform: "uppercase",
		whiteSpace: "nowrap",
		"&::before, &::after": {
			content: '""',
			flex: "1 1 auto",
			height: 1,
			backgroundColor: Colors.body,
		},
		"&::before": { marginRight: 12 },
		"&::after": { marginLeft: 12 },
	},
	providers: {
		display: "flex",
		justifyContent: "center",
	},
	chip: {
		width: 44,
		height: 44,
		margin: "0 12px",
		borderRadius: "50%",
		overflow: "hidden",
		transition: `transform ${TRANSITION}, box-shadow ${TRANSITION}`,
		"&:hover": {
			transform: "translateY(-2px)",
			boxShadow: "0 4px 12px rgba(0, 0, 0, 0.5)",
		},
		"&.Mui-focusVisible": {
			outline: `2px solid ${Colors.pickstop}`,
			outlineOffset: 3,
		},
		"&.Mui-disabled": {
			opacity: 0.35,
			transform: "none",
			boxShadow: "none",
		},
	},
});
